import styles from "../styles/_components/statsCard.module.scss";

const StatsCard = ({ name, value, img }) => {
  return (
    <div className={styles.container}>
      <img src={img} alt={name} />
      <p>{name}</p>
      <h3>{value}</h3>
    </div>
  );
};

export default StatsCard;
